/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./earn.vue?vue&type=template&id=22fc5644&scoped=true"
import script from "./earn.vue?vue&type=script&lang=js"
export * from "./earn.vue?vue&type=script&lang=js"
import style0 from "./earn.vue?vue&type=style&index=0&id=22fc5644&prod&lang=scss"
import style1 from "./earn.vue?vue&type=style&index=1&id=22fc5644&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fc5644",
  null
  
)

export default component.exports